import { ExpiryType, OrderType, TradingSession } from '../../types';
import { atomWithBroadcast } from './atomWithBroadcast';

export type ValidOrderCombo = {
  orderType: OrderType;
  expiryType: ExpiryType;
  tradingSession: TradingSession;
};

export const validOrderCombosAtom = atomWithBroadcast<Record<string, Array<ValidOrderCombo>>>(
  'core/validOrderCombos',
  {},
);
